import React, { useState } from 'react';

function Production() {
  const [products, setProducts] = useState([
    { id: 1, name: 'Стул офисный', sku: 'CH-001', materials: 'Дерево — 2м², Ткань — 0.5м, Саморезы — 8шт', labor: '2 часа', cost: 1200, price: 3500, margin: 2300 },
    { id: 2, name: 'Стол письменный', sku: 'TB-002', materials: 'ЛДСП — 3м², Кромка — 6м, Саморезы — 16шт', labor: '4 часа', cost: 2800, price: 7500, margin: 4700 },
    { id: 3, name: 'Полка настенная', sku: 'SH-003', materials: 'ЛДСП — 1м², Крепёж — 4шт', labor: '1 час', cost: 400, price: 1200, margin: 800 },
    { id: 4, name: 'Шкаф распашной', sku: 'CB-004', materials: 'ЛДСП — 8м², Кромка — 20м, Фурнитура — 1компл', labor: '8 часов', cost: 6500, price: 16000, margin: 9500 },
  ]);

  const [orders, setOrders] = useState([
    { id: 1, product: 'Стул офисный', quantity: 10, status: 'В производстве', start: '10.06.2026', end: '15.06.2026', progress: 60 },
    { id: 2, product: 'Стол письменный', quantity: 5, status: 'Запланирован', start: '16.06.2026', end: '22.06.2026', progress: 0 },
    { id: 3, product: 'Шкаф распашной', quantity: 2, status: 'Завершён', start: '05.06.2026', end: '10.06.2026', progress: 100 },
  ]);

  const getStatusColor = (status) => {
    if (status === 'Завершён') return '#10B981';
    if (status === 'В производстве') return '#F59E0B';
    return '#94A3B8';
  };

  const getProgressColor = (progress) => {
    if (progress >= 100) return '#10B981';
    if (progress >= 50) return '#F59E0B';
    return '#6366F1';
  };

  return (
    <div>
      <h2>🏭 Production Management (ERP)</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 20 }}>
        Product specifications (BOM), production orders, and cost calculation
      </p>

      {/* Спецификации продуктов */}
      <h3 style={{ marginBottom: 10 }}>📋 Product Specifications (BOM)</h3>
      <div style={{ overflowX: 'auto', marginBottom: 24 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
              <th style={{ padding: 6 }}>Product</th>
              <th style={{ padding: 6 }}>SKU</th>
              <th style={{ padding: 6 }}>Materials</th>
              <th style={{ padding: 6 }}>Labor</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Cost</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Price</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Margin</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 6 }}>{p.name}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{p.sku}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{p.materials}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{p.labor}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{p.cost.toLocaleString()} ₽</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{p.price.toLocaleString()} ₽</td>
                <td style={{ padding: 6, textAlign: 'right', color: '#10B981' }}>+{p.margin.toLocaleString()} ₽</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Производственные заказы */}
      <h3 style={{ marginBottom: 10 }}>📦 Production Orders</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ color: '#94A3B8', textAlign: 'left' }}>
              <th style={{ padding: 6 }}>Order</th>
              <th style={{ padding: 6 }}>Product</th>
              <th style={{ padding: 6, textAlign: 'right' }}>Qty</th>
              <th style={{ padding: 6 }}>Start</th>
              <th style={{ padding: 6 }}>End</th>
              <th style={{ padding: 6 }}>Status</th>
              <th style={{ padding: 6 }}>Progress</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #334155' }}>
                <td style={{ padding: 6 }}>#{o.id}</td>
                <td style={{ padding: 6 }}>{o.product}</td>
                <td style={{ padding: 6, textAlign: 'right' }}>{o.quantity}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{o.start}</td>
                <td style={{ padding: 6, color: '#94A3B8' }}>{o.end}</td>
                <td style={{ padding: 6 }}>
                  <span style={{ color: getStatusColor(o.status), fontSize: 12 }}>{o.status}</span>
                </td>
                <td style={{ padding: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ flex: 1, height: 6, background: '#334155', borderRadius: 3, overflow: 'hidden' }}>
                      <div style={{ width: `${o.progress}%`, height: '100%', background: getProgressColor(o.progress), borderRadius: 3 }} />
                    </div>
                    <span style={{ fontSize: 11, color: '#94A3B8' }}>{o.progress}%</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Production;